module.exports = __webpack_public_path__ + "./img/warning-circle.svg";